/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
/* eslint-disable max-len */
import { MutationTree } from 'vuex';
import * as types from '@/store/types';
import { TypeLibrary, TypeState } from './models';

export const mutations: MutationTree<TypeState> = {
  [types.MUTATE_FETCH_TYPES_LIBRARY](state, typesLibrary: TypeLibrary[]) {
    state.typesLibrary = typesLibrary || [];
  },

  [types.MUTATE_ADD_TYPE_LIBRARY](state, newType: TypeLibrary) {
    state.typesLibrary = [...state.typesLibrary, newType];
  },

  [types.MUTATE_DELETE_TYPE_LIBRARY](state, typeId: string) {
    state.typesLibrary = state.typesLibrary.filter((t) => t.id !== typeId);
  },

  [types.MUTATE_UPDATE_TYPE_LIBRARY](state, type: TypeLibrary) {
    const index = state.typesLibrary.findIndex((t) => t.id === type.id);
    if (index !== -1) {
      state.typesLibrary[index] = type;
    }
  },
};
